class GraphAxisLegendDisplayOptions {
    constructor(visible, text, color, offset, fontSize, font) {
        this.visible = typeof visible === 'boolean' ? visible : true;
        this.text = text || "";
        this.color = color || "black";
        this.offset = offset || 35;
        this.fontSize = fontSize || "20px";
        this.font = font || "Arial";
    }
}
export default GraphAxisLegendDisplayOptions;